import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';

@Component({
  template: require('./preview.component.html'),
  styles: [``]
})

export class PreviewComponent implements OnInit {

  constructor(
    private config: ConfigService,
    public cartService: CartService,
    private session: SessionService,
    private router: Router) {
  }

  ngOnInit() {
    if (this.cartService.cart.currentCartProduct.photoResized == null) {
      //console.log('no previewImg - redirect pagecrop');
      this.router.navigate(['/pagecrop']);
    }
    this.cartService.cartCheckProducts();
  }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/preview.component.ts